<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            山东正晨科技领导莅临我司参观交流
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-07-14</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            2026年7月14日，山东高速集团旗下山东正晨科技股份有限公司领导一行莅临山东智能工业装备有限公司参观交流。我司相关负责人热情接待并全程陪同，双方围绕新能源充电基础设施产品布局、技术能力及合作方向进行了深入沟通。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="正晨科技领导莅临我司参观"
            >
            <figcaption class="figure_caption">正晨科技领导一行莅临我司参观指导</figcaption>
          </figure>

          <h2 class="section_title">一、走进现场，了解产品与技术实力</h2>

          <p class="body_paragraph">
            来访领导先后参观了我司充电设备调试区及产品展示区，详细了解公司在新能源充电基础设施领域的产品布局与技术研发情况。我司技术人员重点介绍了720KW四轮充电桩、二轮智能充电桩等核心产品，并围绕设备性能、技术特点及实际应用场景进行了深入讲解与交流。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="充电设备调试区现场交流"
            >
            <figcaption class="figure_caption">充电设备调试区现场交流</figcaption>
          </figure>

          <p class="body_paragraph">
            随后，来访领导前往二轮充电桩区域参观。我司现场介绍了二轮智能充电桩的整体部署方案、扫码充电流程及多重安全防护机制，并就设备在园区、商圈等场景的实际应用进行了交流。来访领导对产品的便捷性与实用性表示关注。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="二轮充电桩参观"
            >
            <figcaption class="figure_caption">二轮充电桩参观</figcaption>
          </figure>

          <h2 class="section_title">二、座谈交流，共谋合作方向</h2>

          <p class="body_paragraph">
            参观结束后，双方举行座谈交流会，围绕新能源充电桩项目建设、设备应用及相关业务合作进行了深入沟通，并就部分合作方向达成初步共识，为后续进一步加强交流、深化合作奠定了良好基础。
          </p>

          <figure class="figure_block figure_block--end">
            <img
              class="article_img"
              :src="images.img4"
              alt="双方座谈交流"
            >
            <figcaption class="figure_caption">双方座谈交流</figcaption>
          </figure>

          <p class="body_paragraph">
            此次正晨科技领导莅临参观，进一步增进了双方互信与了解。下一步，双方将保持密切沟通，推动合作事项落地见效，共同助力新能源充电产业高质量发展。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news8/image1.jpg'),
        img2: require('@/assets/images/news-list/news8/image2.jpg'),
        img3: require('@/assets/images/news-list/news8/image3.jpg'),
        img4: require('@/assets/images/news-list/news8/image4.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
